var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"space-y-8"},[_c('div',[_c('AccountAddAction',{attrs:{"contact-id":_vm.contactId},on:{"account-added":_vm.onAccountAdded}})],1),_c('div',[_c('AccountList',{ref:"accountList",attrs:{"contact-id":_vm.contactId},on:{"change":function($event){return _vm.$emit('refresh')}}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }